export default "# How does Partial Common Ownership work?";